<ng-container *transloco="let t; prefix: 'driverInformation'">
@if (isLoading) {
  <div class="driver-wrapper pe-4">
    <div class="d-flex justify-content-center align-items-center spinner-container">
      <span class="spinner-border"></span>
    </div>
  </div>
}
@if (isDriverSelected && driver && !isLoading) {
  <div class="driver-details-content">
    <div class="driver-wrapper pe-4">
      <form #driverInformationForm="ngForm">
        <div class="driver-details d-flex gap-3 flex-column">
          <!-- Header -->
          <div class="driver-details__header">
            <div class="driver-details__employee-info d-flex flex-column gap-2">
              <span class="driver-details__employee-name">{{ driver.firstName }} {{ driver.lastName
              }}</span>
              <span class="driver-details__employee-company">{{ driver.accountName }}</span>
            </div>
            <div class="driver-details__header-control d-flex gap-2">
              <button class="btn btn-primary" (click)="openAppCredentialsButton()">{{appCredentialLabel}}</button>
              @if (isPayrollAdmin) {
                <div class="driver-details__setting" (click)="openDriverInformationSettingsModal()">
                  <i class="ph ph-gear-six"></i>
                </div>
              }
            </div>
          </div>
          <div class="driver-stats bg-white rounded">
            <div class="d-flex justify-content-between">
              <div class="w-auto d-flex align-items-center driver-stats__item">
                <i class="ph-duotone text-secondary ph-line-segment driver-stats__icon"></i>
                <div class="driver-stats__info">
                  <h5 class="driver-stats__value fw-bold">{{driverTripsOverview?.driverId ?
                  driverTripsOverview?.totalDistance?.toLocaleString() :'-' }}</h5>
                  <p class="driver-stats__label">{{ t('stats.distanceDriven', { unit: driverTripsOverview?.unit || 'km' }) }}
                  </p>
                </div>
              </div>
              <div class="w-auto d-flex align-items-center driver-stats__item">
                <i class="ph-duotone text-secondary ph-check-fat driver-stats__icon"></i>
                <div class="driver-stats__info">
                  <h5 class="driver-stats__value fw-bold">{{driverTripsOverview?.driverId ?
                  driverTripsOverview?.tripsCompleted : '-'}}</h5>
                  <p class="driver-stats__label">{{ t('stats.tripsCompleted') }}</p>
                </div>
              </div>
              <div class="w-auto d-flex gap-2 align-items-end justify-content-between driver-stats__item">
                <div class="d-flex align-items-center">
                  <i class="ph-duotone text-secondary ph-clock-afternoon driver-stats__icon"></i>
                  <div class="driver-stats__info">
                    <h5 class="driver-stats__value fw-bold">
                      {{ driver.driverLicenseRenewal ? (driver.driverLicenseRenewal | date: 'yyyy/MM/dd') : '-' }}
                    </h5>
                    <p class="driver-stats__label">{{ t('stats.licenseValidity') }}</p>
                  </div>
                </div>
                @if (isLicenseExpiringSoon()) {
                  <span class="driver-stats__expiring_soon_badge" [ngbTooltip]="driverNotificationMessage"
                    >{{ t('status.expiringSoon') }}</span>
                }
                @if (isLicenseExpired()) {
                  <span class="driver-stats__expiring_soon_badge" [ngbTooltip]="driverNotificationMessage"
                  class="driver-stats__expired_badge">{{ t('status.expired') }}</span>
                }
              </div>
              <div class="w-auto d-flex gap-2 align-items-end justify-content-between driver-stats__item">
                <div class="d-flex align-items-center">
                  <i class="ph-duotone text-secondary ph-clock-afternoon driver-stats__icon"></i>
                  <div class="driver-stats__info">
                    <h5 class="driver-stats__value fw-bold">
                      {{ driver.professionalDriversPermitRenewalDate ? (driver.professionalDriversPermitRenewalDate | date: 'yyyy/MM/dd') : '-' }}
                    </h5>
                    <p class="driver-stats__label">{{ t('stats.permitValidity') }}</p>
                  </div>
                </div>
                @if (isPdpExpiringSoon()) {
                  <span class="driver-stats__expiring_soon_badge" [ngbTooltip]="pdpNotificationMessage"
                  >{{ t('status.expiringSoon') }}</span>
                }
                @if (isPdpExpired()) {
                  <span class="driver-stats__expiring_soon_badge" [ngbTooltip]="pdpNotificationMessage"
                  class="driver-stats__expired_badge">{{ t('status.expired') }}</span>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="driver-profile">
          <div class="driver-profile__wrapper row gx-4">
            <!-- Left Section: Driver Info -->
            <div class=" col-md-5">
              <div class="driver-profile__info">
                <div class="driver-profile__photo">
                  <app-avatar [imageSrc]="photoFile? photoFile: driver.profilePictureUrl!"
                  [name]="driver.firstName +' '+ driver.lastName" [size]="96"></app-avatar>
                  <label for="photoInput" class="driver-profile__change-photo">{{ t('fields.changePhoto') }}</label>
                  <input type="file" name="photoInput" id="photoInput" hidden (change)="onPhotoSelected($event)">
                </div>
                <div class="form-group">
                  <div class="driver-profile__form">
                    <div class="row gx-3">
                      <div class="col-lg-6 col-md-12 driver-profile__field">
                        <label class="driver-profile__label">{{ t('fields.firstName') }}</label>
                        <input required [(ngModel)]="driver.firstName" name="firstName" #firstName="ngModel" type="text"
                          class="form-control driver-profile__input" value="{{driver.firstName}}">
                          <app-form-error-message [control]="firstName"
                            [errorMessage]="getErrorMessage(firstName,'firstName')"
                          [formSubmitted]="formSubmitted"></app-form-error-message>
                        </div>
                        <div class="col-lg-6 col-md-12 driver-profile__field">
                          <label class="driver-profile__label">{{ t('fields.lastName') }}</label>
                          <input required [(ngModel)]="driver.lastName" name="lastName" #lastName="ngModel" type="text"
                            class="form-control driver-profile__input" value="{{driver.lastName}}">
                            <app-form-error-message [control]="lastName" [errorMessage]="getErrorMessage(lastName,'lastName')"
                            [formSubmitted]="formSubmitted"></app-form-error-message>
                          </div>
                        </div>
                        <div class="driver-profile__field">
                          <app-flatpickr-date-picker
                            [label]="t('fields.dateOfBirth')"
                            [(value)]="driver.dateOfBirth"
                            maxDate="today"
                            [yearsAhead]="0"
                            [allowPastDates]="true">
                          </app-flatpickr-date-picker>
                        </div>
                        <div class="driver-profile__field">
                          <label class="driver-profile__label">{{ t('fields.phoneNumber') }}</label>
                          <input required minlength="10" pattern="^[0-9]*$" type="tel" maxlength="15"
                            [(ngModel)]="driver.phoneNumber" name="phoneNumber" #phoneNumber="ngModel"
                            class="form-control driver-profile__input" value="{{driver.phoneNumber}}">
                            <app-form-error-message [control]="phoneNumber"
                              [errorMessage]="getErrorMessage(phoneNumber,'phoneNumber')"
                            [formSubmitted]="formSubmitted"></app-form-error-message>
                          </div>
                          <div class="driver-profile__field">
                            <label class="driver-profile__label">{{ t('fields.altPhoneNumber') }}</label>
                            <input type="tel" minlength="10" maxlength="15" [(ngModel)]="driver.alternativePhoneNumber"
                              name="alternativePhoneNumber" #alternativePhoneNumber="ngModel" type="text"
                              class="form-control driver-profile__input" value="{{driver.alternativePhoneNumber}}">
                              <app-form-error-message [control]="alternativePhoneNumber"
                                [errorMessage]="getErrorMessage(alternativePhoneNumber,'alternativePhoneNumber')"
                              [formSubmitted]="formSubmitted"></app-form-error-message>
                            </div>
                            <div class="driver-profile__field">
                              <label class="driver-profile__label">{{ t('fields.email') }}</label>
                              <input required [email]="true" [(ngModel)]="driver.email" name="email" #email="ngModel" type="email"
                                class="form-control driver-profile__input" value="{{driver.email}}">
                                <app-form-error-message [control]="email"
                                  [errorMessage]="email.errors?.['email'] ? t('validation.invalidEmail') : getErrorMessage(email,'email')"
                                [formSubmitted]="formSubmitted"></app-form-error-message>
                              </div>
                              <div class="driver-profile__field">
                                <label class="driver-profile__label">{{ t('fields.address') }}</label>
                                <input required [(ngModel)]="driver.address" name="address" #address="ngModel" type="text"
                                  class="form-control driver-profile__input" value="{{driver.address}}">
                                  <app-form-error-message [control]="address" [errorMessage]="getErrorMessage(address,'address')"
                                  [formSubmitted]="formSubmitted"></app-form-error-message>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- Right Section: Driver Details -->
                        <div class=" col-md-7">
                          <div class="driver-profile__details">
                            <h3 class="driver-profile__title mb-3">{{ t('details.title') }}</h3>
                            <div class="row gx-3">
                              <div class="col-lg-6 col-md-12 driver-profile__field">
                                <label class="driver-profile__label">{{ t('fields.idNumber') }}</label>
                                <input [required]="isDriverIdRequired()" [(ngModel)]="driver.driverIdNumber" name="driverIdNumber"
                                  #driverIdNumber="ngModel"
                                  [ngClass]="alertMessage && oldIdNumber == this.driver.driverIdNumber ? 'invalid-input' :''"
                                  type="text" class="form-control driver-profile__input" value="{{ driver.driverIdNumber }}">
                                  <app-form-error-message [control]="driverIdNumber"
                                    [errorMessage]="getErrorMessage(driverIdNumber,'driverIdNumber')"
                                  [formSubmitted]="formSubmitted"></app-form-error-message>
                                  <app-form-error-message [isEnabled]="!!alertMessage && oldIdNumber == this.driver.driverIdNumber"
                                    [errorMessage]="alertMessage" [formSubmitted]="formSubmitted">
                                  </app-form-error-message>
                                </div>
                                <div class="col-lg-6 col-md-12 driver-profile__field">
                                  <label class="driver-profile__label">{{ t('fields.passportNumber') }}</label>
                                  <input [required]="isPassportRequired()" [(ngModel)]="driver.passportNumber" name="passportNumber"
                                    #passportNumber="ngModel" type="text" class="form-control driver-profile__input"
                                    value="{{driver.passportNumber}}">
                                    <app-form-error-message [control]="passportNumber"
                                      [errorMessage]="getErrorMessage(passportNumber, 'passportNumber')" [formSubmitted]="formSubmitted">
                                    </app-form-error-message>
                                    <app-form-error-message
                                      [isEnabled]="!!passportAlertMessage && oldPassportNumber == this.driver.passportNumber"
                                      [errorMessage]="passportAlertMessage" [formSubmitted]="formSubmitted">
                                    </app-form-error-message>
                                  </div>
                                </div>
                                <div class="row gx-3">
                                  <div class="col-lg-6 col-md-12 driver-profile__field">
                                    <div class="d-flex align-items-center gap-2">
                                      <label class="driver-profile__label ">{{ t('fields.driverLicenseRenewal') }}</label>
                                      @if (isLicenseExpired() || isLicenseExpiringSoon()) {
                                        <svg [ngbTooltip]="driverNotificationMessage"
                                          [animation]="true" class="driver-profile__notification_icon" width="16" height="16"
                                          viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M8.26424 1.33301C4.60557 1.33301 1.62891 4.32367 1.62891 7.99967C1.62891 11.6757 4.61957 14.6663 8.29557 14.6663C11.9716 14.6663 14.9622 11.6757 14.9622 7.99967C14.9622 4.32367 11.9576 1.33301 8.26424 1.33301ZM8.96224 11.333H7.62891V9.99967H8.96224V11.333ZM8.96224 8.66634H7.62891V4.66634H8.96224V8.66634Z"
                                            [attr.fill]="isLicenseExpiringSoon() ? '#F4BC2B' : '#FF7F00'" />
                                          </svg>
                                        }
                                      </div>
                                      <div class="date-input-wrapper">
                                        <input class="form-control driver-profile__input" type="text" name="driverLicenseRenewal"
                                          [disabled]="true" [placeholder]="'yyyy/mm/dd'" [value]="driver.driverLicenseRenewal | date: 'yyyy/MM/dd'" />
                                        </div>
                                      </div>
                                      <div class="col-lg-6 col-md-12 driver-profile__field">
                                        <div class="d-flex align-items-center gap-2">
                                          <label class="driver-profile__label">{{ t('fields.pdpRenewal') }}</label>
                                          @if (isPdpExpired() || isPdpExpiringSoon()) {
                                            <svg [ngbTooltip]="pdpNotificationMessage"
                                              [animation]="true" class="driver-profile__notification_icon" width="16" height="16"
                                              viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path [attr.fill]="isPdpExpiringSoon() ? '#F4BC2B' : '#FF7F00'"
                                                d="M8.26424 1.33301C4.60557 1.33301 1.62891 4.32367 1.62891 7.99967C1.62891 11.6757 4.61957 14.6663 8.29557 14.6663C11.9716 14.6663 14.9622 11.6757 14.9622 7.99967C14.9622 4.32367 11.9576 1.33301 8.26424 1.33301ZM8.96224 11.333H7.62891V9.99967H8.96224V11.333ZM8.96224 8.66634H7.62891V4.66634H8.96224V8.66634Z" />
                                              </svg>
                                            }
                                          </div>
                                          <div class="date-input-wrapper">
                                            <input class="form-control driver-profile__input" type="text" name="professionalDriversPermitRenewalDate"
                                              [disabled]="true" [placeholder]="'yyyy/mm/dd'" [value]="driver.professionalDriversPermitRenewalDate | date: 'yyyy/MM/dd'" />
                                            </div>
                                          </div>
                                        </div>
                                        <div class="driver-profile__field">
                                          <label class="driver-profile__label">{{ t('fields.comments') }}</label>
                                          <textarea [(ngModel)]="driver.comments" name="comments" #comments="ngModel"
                                            class="form-control driver-profile__textarea" [placeholder]="t('fields.commentsPlaceholder')">
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="d-flex justify-content-end py-4">
                                      <div class="w-auto" (click)="openDeleteDriverConfirmationModal(driver)">
                                        <button type="submit"
                                          class="btn btn-primary btn-update-driver btn-delete d-flex justify-content-center align-items-center position-relative gap-2">
                                          <span class="px-2">{{ t('details.removeDriver') }}</span>
                                        </button>
                                      </div>
                                      <div class="w-auto ms-3">
                                        <button type="submit" (click)="updateDriverDetails()"
                                          [disabled]="isUpdating || !driverInformationForm.valid"
                                          class="btn btn-primary btn-update-driver d-flex justify-content-center align-items-center position-relative gap-2">
                                          @if (isUpdating) {
                                            <span class="spinner-border"></span>
                                          }
                                          <span class="px-2">{{ 'common.update' | transloco }}</span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        }
                        <!-- driver actions -->
                        @if (isDriverSelected && driver && !isLoading) {
                          <div class="driver-actions">
                            <div class="driver-actions__wrapper d-flex justify-content-between align-items-center">
                              <!-- Left Buttons -->
                              <div class="driver-actions__group">
                                <!-- <button class="driver-actions__button btn btn-outline-danger">
                                Fines <i class="ph ph-hand-coins"></i>
                              </button> -->
                              <button class="driver-actions__button btn btn-outline-danger" [routerLink]="['/driver-management/driver-documents', driver.id]">
                                {{ t('details.driverDocuments') }} <i class="ph ph-identification-card"></i>
                              </button>
                            </div>
                            <!-- Right Buttons -->
                            <div class="driver-actions__group">
                              <div class="d-flex gap-1">
                                <button class="driver-actions__button btn btn-outline-danger btn--vehicles" (click)="showAssignedVehicles()" [disabled]="assignedVehiclesCount === 0">
                                  {{ t('details.vehicles', { count: assignedVehiclesCount }) }}
                                </button>
                                <button class="driver-actions__button btn btn-outline-danger btn--plus" (click)="onAssignAssetsClick(driver.id)">
                                  @if (!isAssetFilterLoading) {
                                    <i class="ph ph-plus"></i>
                                  }
                                  @if (isAssetFilterLoading) {
                                    <span class="spinner-border assign"></span>
                                  }
                                </button>
                              </div>
                              <!-- <div class="d-flex gap-1">
                              <button class="driver-actions__button btn btn-outline-danger">
                                Accidents/incidents (100)
                              </button>
                              <button class="driver-actions__button btn btn-outline-danger btn--plus">
                                <i class="ph ph-plus"></i>
                              </button>
                            </div> -->
                          </div>
                        </div>
                      </div>
                    }
</ng-container>